var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.421656 5.27372C0.262223 5.12315 0 5.23618 0 5.45547V15.5C0 16.0523 0.447716 16.5 1 16.5H17C17.5523 16.5 18 16.0523 18 15.5V5.45548C18 5.23618 17.7378 5.12315 17.5783 5.27373L9.68663 12.727C9.30123 13.091 8.69877 13.091 8.31338 12.727L0.421656 5.27372ZM17.3134 2.77299C17.3888 2.70172 17.3857 2.57121 17.2862 2.54155C17.1955 2.51452 17.0995 2.5 17 2.5H1C0.900545 2.5 0.804481 2.51452 0.713812 2.54155C0.614347 2.57121 0.611168 2.70172 0.686626 2.77299L8.82835 10.4624C8.9247 10.5534 9.07531 10.5534 9.17166 10.4624L17.3134 2.77299Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.3afd5c840281e904104fec3bd345168d.svg";
export { ForwardRef as ReactComponent };